import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Timestamp, TextOverflowEllipsis, IconButton } from "components/common";
import { evidenceTypeLabel } from "security-app/components/Investigations/Details/TimelineSegment/Utils";
import { Badge, ButtonToolbar, Button } from "components/bootstrap";
export const evidenceCardId = (evidenceId) => `evidence-card-${evidenceId}`;
const Container = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  flex-direction: column;
`;
const TopRow = styled.div`
  display: flex;
  width: 100%;
  gap: 4px;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;
const LeftHeaderCol = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  flex-wrap: wrap;
`;
const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${theme.fonts.size.small};
  `
);
const StyledTimestamp = styled(Timestamp)(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
  `
);
const Title = styled.h5`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
const Subtitle = styled(TextOverflowEllipsis)(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
    font-size: ${theme.fonts.size.small};
    margin-top: 4px;
  `
);
const StyledButtonToolbar = styled(ButtonToolbar)`
  flex-wrap: wrap;
`;
const EvidenceCardFoundation = ({
  children = void 0,
  actions,
  evidence,
  hasSimilarFieldsFilter,
  onResetShowSimilar,
  onShowSimilar,
  subtitle = void 0,
  title,
  isHighlighted = false,
  canSeeEventDefinition = true
}) => {
  const [showMore, setShowMore] = useState(hasSimilarFieldsFilter);
  const [showingSimilar, setShowingSimilar] = useState(false);
  const typeTitle = evidenceTypeLabel(evidence.type);
  const toggleFields = () => setShowMore((cur) => !cur);
  const showSimilar = async () => {
    setShowingSimilar(true);
    onShowSimilar(evidence).finally(() => {
      setShowingSimilar(false);
    });
  };
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(TopRow, null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(LeftHeaderCol, null, isHighlighted ? /* @__PURE__ */ React.createElement(Badge, { bsStyle: "primary" }, "Selected ", typeTitle) : /* @__PURE__ */ React.createElement("b", null, typeTitle), /* @__PURE__ */ React.createElement(StyledTimestamp, { dateTime: evidence.timestamp })), canSeeEventDefinition && /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: showMore ? "keyboard_arrow_up" : "keyboard_arrow_down",
      onClick: toggleFields,
      title: `Show ${evidenceTypeLabel(evidence.type, true)} details`
    }
  )), /* @__PURE__ */ React.createElement(Title, null, title), subtitle && /* @__PURE__ */ React.createElement(Subtitle, null, subtitle)), showMore && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(StyledButtonToolbar, null, actions, hasSimilarFieldsFilter ? /* @__PURE__ */ React.createElement(Button, { onClick: onResetShowSimilar, bsSize: "small" }, "Reset") : /* @__PURE__ */ React.createElement(Button, { onClick: showSimilar, bsSize: "small", disabled: showingSimilar }, showingSimilar ? "Showing..." : "Show similar")), children));
};
export default EvidenceCardFoundation;
